const ACCORDION_DETAILS_SELECTOR =
  '.faq__item, .footer-accordion__item, .product__accordion > details';

class AccordionTransition {
  static instances = new WeakMap();

  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.panel = details.querySelector('.accordion-transition__panel');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.isAnimating = false;

    if (!this.summary || !this.panel) return;

    AccordionTransition.instances.set(details, this);
    this.bind();

    if (details.open) {
      this.setExpanded(true, false);
    }
  }

  static close(details) {
    const instance = AccordionTransition.instances.get(details);
    if (instance) {
      instance.close();
    } else {
      details.open = false;
    }
  }

  bind() {
    if (this.reducedMotion) return;

    this.summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.isAnimating) return;

      if (this.details.open) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  setExpanded(expanded, animate = true) {
    if (!animate) {
      this.details.classList.add('accordion-transition--instant');
    }

    if (expanded) {
      this.details.open = true;
      this.panel.classList.add('is-expanded');
      this.updateAria(true);
    } else {
      this.panel.classList.remove('is-expanded');
      this.details.open = false;
      this.updateAria(false);
    }

    if (!animate) {
      requestAnimationFrame(() => {
        this.details.classList.remove('accordion-transition--instant');
      });
    }
  }

  open() {
    this.isAnimating = true;
    this.panel.classList.remove('is-expanded');
    this.details.open = true;
    this.updateAria(true);

    void this.panel.offsetHeight;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.panel.classList.add('is-expanded');
      });
    });

    this.panel.addEventListener('transitionend', this.onOpenEnd, { once: true });
  }

  onOpenEnd = (event) => {
    if (event.target !== this.panel || event.propertyName !== 'grid-template-rows') return;
    this.isAnimating = false;
  };

  close() {
    if (!this.details.open) return;

    if (!this.panel.classList.contains('is-expanded')) {
      this.details.open = false;
      this.updateAria(false);
      this.isAnimating = false;
      return;
    }

    this.isAnimating = true;
    this.panel.classList.remove('is-expanded');
    this.panel.addEventListener('transitionend', this.onCloseEnd, { once: true });
  }

  onCloseEnd = (event) => {
    if (event.target !== this.panel || event.propertyName !== 'grid-template-rows') return;

    this.details.open = false;
    this.updateAria(false);
    this.isAnimating = false;
  };

  updateAria(expanded) {
    this.summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }
}

function initAccordionTransitions(root) {
  root.querySelectorAll(ACCORDION_DETAILS_SELECTOR).forEach((details) => {
    if (AccordionTransition.instances.has(details)) return;
    new AccordionTransition(details);
  });
}

window.AccordionTransition = AccordionTransition;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAccordionTransitions(document));
} else {
  initAccordionTransitions(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initAccordionTransitions(event.target);
});
